// extracted by mini-css-extract-plugin
module.exports = {"container":"Dropdown_container__3HugD","icon":"Dropdown_icon__3hTCY","type_name":"Dropdown_type_name__1VP_C"};